<template>
  <!-- 费项类型维护 -->
  <div>
    <div class="box">
      <!-- 左边 -->
      <div class="boxleft glo_Table">
        <el-table
          ref="leftTable"
          :data="menuTableData"
          style="width: 100%"
          row-key="categoryId"
          border
          :height="leftHeight"
          lazy
          :load="loadMore"
          @row-click="rowClickLeft"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            prop="categoryName"
            label="费项类型"
            sortable
            width="200"
          />
          <el-table-column fixed="right">
            <template slot="header">
              <span> 操作 </span>
              <i
                class="el-icon-circle-plus-outline"
                style="color: #409eff; font-size: 20px; margin-left: 10px"
                @click="menuadd"
              />
            </template>
            <template slot-scope="scope">
              <el-button type="text" size="small">
                <span
                  v-if="hasPermiss('admin:itemservice:addItemCategory')"
                  class="tablebut"
                  @click.stop="menuadd(scope.row)"
                  >添加</span
                >
                <span
                  v-if="hasPermiss('admin:itemservice:updateItemCategor')"
                  class="tablebut"
                  @click.stop="menumodify(scope.row, 'left')"
                  >修改</span
                >
                <span
                  v-if="hasPermiss('admin:itemservice:delItemCategory')"
                  class="tablebut"
                  @click.stop="delBtns(scope.row.categoryId, 'left')"
                  >删除</span
                >
                <span
                  v-if="hasPermiss('admin:itemservice:startItemCategory')"
                  class="tablebut"
                  @click.stop="
                    isStopLeftClick(scope.row.categoryId, scope.row.isStop)
                  "
                  >{{ scope.row.isStop == 0 ? "禁用" : "启用" }}</span
                >
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 右边 -->
      <div class="boxright">
        <set-expenditure />
      </div>
    </div>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="PopUpTitle"
      :isShowDialog="menushowBOX"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('CalculationRulesRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="menushowBOX"
          ref="CalculationRulesRef"
          :model="CalculationRules"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item
            class="dialogFormItems"
            prop="categoryName"
            label="类型名称:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="CalculationRules.categoryName"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="parentId"
            label="上级类型:"
          >
            <el-select
              v-model="CalculationRules.parentId"
              clearable
              :disabled="disabled"
              placeholder="请输入关键词"
              filterable
              remote
              :loading="false"
              :remote-method="remoteMethod2"
            >
              <el-option
                v-for="(item, index) in SuperiorRegionList2"
                :key="index"
                :label="item.categoryName"
                :value="item.categoryId"
              />
            </el-select>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="isStop" label="启用状态:">
            <el-select
              clearable
              v-model="CalculationRules.isStop"
              placeholder="请选择"
            >
              <el-option label="禁用" :value="1" />
              <el-option label="启用" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input
              placeholder="请输入"
              v-model="CalculationRules.sort"
              clearable
            ></el-input>
          </el-form-item>
          <!-- <el-form-item class="dialogFormItems" prop="serviceStatus" label="服务类型:">
            <el-select clearable v-model="CalculationRules.serviceStatus" placeholder="请选择">
              <el-option label="打包服务" value="da_bao:service_status" />
              <el-option label="验货服务" value="yan_huo:service_status" />
              <el-option label="退货服务" value="tui_huo:service_status" />
              <el-option label="异常服务" value="yi_chang:service_status" />
              <el-option label="问题服务" value="wen_ti:service_status" />
              <el-option label="其他服务" value="qi_ta:service_status" />
            </el-select>
          </el-form-item> -->
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="CalculationRules.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>


<script>
import paging from "@/components/pagings.vue";
import queryBtns from "@/components/queryBtns.vue";
import myDialog from "@/components/Dialog.vue";
import SetExpenditure from "@/pages/FinancialManagement/ManageQuotes/SetExpenditure.vue";
export default {
  inject: ["reload"],
  components: {
    paging,
    queryBtns,
    myDialog,
    SetExpenditure,
  },
  data() {
    return {
      CalculationRules: {
        serviceStatus: "",
        categoryName: "", //
        isStop: 0, //
        parentId: "", //菜单排序
        remarks: "", //
        sort: "", //
        loading: false,
      },
      disabled: false,
      rules: {
        serviceStatus: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      PopUpTitle: "", //弹窗标题
      menushowBOX: false, //菜单弹窗
      menuTableData: [],
      diaWidth: "40%",
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

      queryData: {
        categoryName: "",
        parentId: "",
      },

      // ================
      pageStart: 1, //页码
      total: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      pageTotal: this.$COMMON.pageTotals, //一页几条
      nextPage: false, //是否有下一页
      show_sortTableHeard: false, //显示弹窗
      show_upload: false, //显示上传弹窗
      myTableHeard: [], //我的表头
      originalTabelHeadeTitle: [],
      selectLength: 0, //显示的长度
      allCheck: false, //全选
      leftHeight: "50vh",
      tableHeigth: "50vh",
      tabelHeadeTitle: [
        {
          name: "费项类型名称",
          field: "categoryName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "140",
        },
        {
          name: "上级类型",
          field: "parentName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "排序",
          field: "sort",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "是否停用",
          field: "isStopShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "备注",
          field: "remarks",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },

        {
          name: "	服务类型",
          field: "serviceStatusShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },

        {
          name: "创建人",
          field: "createUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
      ],
      tableData: [],
      totalArr: [], //需要合计的字段
      className: "", //导出需要
      fieldName: [], //下载字段名
      head: [], //下载表头字段
      fileList: [],
      sortName: "费项类型维护", //排序名
      pageGroupName: "MtExpenditures", //页面标识
      selectTableData: [], //选中的数据

      deperIds: [],
      isStopLeft: "启用",
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      SuperiorRegionList: [], //上级地区
      SuperiorRegionList2: [], //上级地区(弹窗的)
      dialogType: "", //add==新建  edit==编辑
      ClickLR: "", //left==左边列表的编辑 right==右边列表的编辑
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    if (this.originalTabelHeadeTitle.length == 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.myTableHeard = this.tabelHeadeTitle;
    // this.getGroupFindFieldSort(); //获取用户自定义表头

    this.endtime = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.sarttime = this.$TOOLS.getFlexDate(-3); //三天前
    this.times = [this.sarttime, this.endtime];
    this.getItemCategorLeftList();
    this.getParentName(); //默认查到各省
  },
  mounted() {
    const that = this;
  },
  activated() {
    this.$nextTick(() => {
      this.fetTableHeight_left();
    });
  },
  watch: {},
  methods: {
    // 左边表格
    getItemCategorLeftList() {
      this.$API.itemCategorLeftList().then((res) => {
        if (res.data.status == "success") {
          let bmList = res.data.result || [];
          bmList.forEach((item, index) => {
            item.children = [];
            item.hasChildren = true;
          });
          this.menuTableData = bmList;
        }
      });
    },

    // 查询条件上级地区发生变化时
    changeParentAddress() {
      this.queryBtn_ok();
    },
    // 上级地区远程搜索
    remoteMethod(e) {
      this.$API.itemCategorChoose({ categoryName: p }).then((res) => {
        this.SuperiorRegionList = res.data.result.data || [];
      });
    },
    // 弹窗上级地区远程搜索
    remoteMethod2(e) {
      let pN = "";
      let p = {
        pageStart: 1,
        pageTotal: 100,
        categoryName: e,
        // parentName: pN,
      };
      this.$API.itemCategorChoose(p).then((res) => {
        this.SuperiorRegionList2 = res.data.result || [];
      });
    },

    // 默认所有费型类型
    getParentName(e) {
      let p = {
        categoryName: e,
      };
      this.$API.itemCategorChoose(p).then((res) => {
        this.SuperiorRegionList = res.data.result || [];
      });
    },
    rowClickLeft(tree) {
      this.queryData.categoryName = tree.categoryName;
      this.queryData.parentId = tree.categoryId;
    },
    // 加载下一级
    loadMore(tree, treeNode, resolve) {
      let pid = tree.categoryId || "";
      this.$API.itemCategorLeftList({ parentId: pid }).then((res) => {
        if (res.data.status == "success") {
          let bmList = res.data.result || [];
          bmList.forEach((item) => {
            item.children = [];
            item.hasChildren = true;
          });
          resolve(bmList);
        }
      });
      this.rowClickLeft(tree);
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    clerBtns() {
      //  重置按钮
      this.queryData = {
        categoryName: "",
        parentId: "",
      };
    },

    isStopLeftClick(id, isstop) {
      // isstop为true表示禁用了，所以调相反的借口
      if (isstop) {
        this.qiYong(id);
      } else {
        this.jinYong(id);
      }
    },
    // 启用
    qiYong(id) {
      let ids = [id]; //先清空之前的数据
      this.$confirm("是否启用所选费项类型", "提示:").then((res) => {
        this.$API.startItemCategory({ categoryIds: ids }).then((res) => {
          this.$message.success(res.data.message || "");
          this.getItemCategorLeftList();
        });
      });
    },
    // 禁用
    jinYong(id) {
      let ids = [id]; //先清空之前的数据
      this.$confirm("是否禁用所选费项类型", "提示:").then((res) => {
        this.$API.stopItemCategory({ categoryIds: ids }).then((res) => {
          this.$message.success(res.data.message || "");
          this.getItemCategorLeftList();
        });
      });
    },

    // 递归获取部门下所有id
    getDpIds(data) {
      let ids = this.deperIds || [];
      ids.push(data.departmentId);
      let arrs = data.children || [];
      for (var i = 0; i < arrs.length; i++) {
        ids.push(arrs[i].departmentId);
        let arr2 = arrs[i].children || [];
        for (var j = 0; j < arr2.length; j++) {
          this.getDpIds(arr2[j]);
        }
      }
      this.deperIds = ids;
      return this.deperIds;
    },

    //递归获取数据
    diGuiGetMeun(data, parentId) {
      let tree = [];
      let temp;
      data.forEach((item) => {
        if (item.parentId == parentId) {
          let obj = item;
          obj.departmentName = item.departmentName;
          obj.children = [];
          temp = this.diGuiGetMeun(data, item.departmentId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      });
      //排序
      for (var i = 0; i < tree.length - 1; i++) {
        for (var j = 0; j < tree.length - 1 - i; j++) {
          if (tree[j].sort > tree[j + 1].sort) {
            let temp = tree[j + 1];
            tree[j + 1] = tree[j];
            tree[j] = temp;
          }
        }
      }
      return tree;
    },
    //新建
    menuadd(row) {
      this.disabled = false;
      if (row) {
        this.remoteMethod2(row.categoryName);
        this.disabled = true;
        this.CalculationRules.parentId = row.categoryId;
      } else {
        this.remoteMethod2();
      }
      this.PopUpTitle = "费项类型";
      this.menushowBOX = true;
      this.dialogType = "add";
    },
    //修改
    menumodify(row, type) {
      this.CalculationRules = row;
      this.disabled = false;
      if (row.parentId == "-1") {
        this.SuperiorRegionList2 = [
          { categoryName: "第一级", categoryId: "-1" },
        ];
        this.disabled = true;
      } else {
        this.remoteMethod2(row.categoryName);
      }

      this.ClickLR = type;
      this.PopUpTitle = "费项类型";
      this.menushowBOX = true;
      this.dialogType = "edit";
    },
    // 删除
    delBtns(id, type) {
      let ids = [id];
      this.$confirm("是否删除所选数据?", "提示:")
        .then(() => {
          this.$API.delItemCategory({ categoryIds: ids }).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.getItemCategorLeftList();
            }
          });
        })
        .catch(() => {});
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.menushowBOX = false;
      this.CalculationRules = {
        districtName: "",
        parentId: "", //
        isEnable: "0", //
        sort: "1", //菜单排序
        remarks: "", //
      };
      this.getParentName("中华人民共和国"); //默认查到各省
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valide) => {
        if (valide) {
          let param = {
            serviceStatus: "qi_ta:service_status",
            categoryName: this.CalculationRules.categoryName || "",
            parentId: this.CalculationRules.parentId || "",
            isStop: this.CalculationRules.isStop || "0",
            remarks: this.CalculationRules.remarks || "",
            sort: this.CalculationRules.sort || "1",
          };
          if (this.dialogType == "add") {
            // 新建
            this.$API.addItemCategory(param).then((res) => {
              this.$message.success(res.data.message || "success");
              this.menushowBOX = false;

              this.getItemCategorLeftList();
            });
          } else {
            // 修改
            param.categoryId = this.CalculationRules.categoryId || "";
            this.$API.updateItemCategor(param).then((res) => {
              this.$message.success(res.data.message || "success");
              this.menushowBOX = false;
              this.getItemCategorLeftList();
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.menushowBOX = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    /**
     * =========================按钮部分的方法=>开始??????????????????????????????????
     */

    //导出操作
    handleCommand_dc(command) {
      if (command == "dc") {
        // 导出
        this.exportBtn();
      } else if (command == "dcmb") {
        // 下载模板
        this.exportTemplateDownload();
      } else if (command == "scmb") {
        // 上传模板
        this.upLoadBtn();
      }
    },

    // ===============================================导出部分=结束======

    /**
     * ******************************计算表格高度**开始*************************
     */
    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight_left() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      this.$nextTick(() => {
        this.leftHeight = windonHeight - 85;
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    // 获取自定义的排序,没有就用默认的
    getGroupFindFieldSort() {
      let that = this;
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              that.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            that.myTableHeard = that.tabelHeadeTitle;
          }
          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < that.myTableHeard.length; i++) {
            if (that.myTableHeard[i].isTotal) {
              totalArr.push(that.myTableHeard[i].field);
            }
          }
          that.totalArr = totalArr;
        });

      that.$nextTick(() => {
        that.$refs.mytable.doLayout();
      });
    },
    // 设置模板按钮
    myModel() {
      let that = this;
      that.show_sortTableHeard = true;
      that.tabelHeadeTitle = JSON.parse(JSON.stringify(that.myTableHeard));
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },

    // 排序==>取消按钮
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮
    confirmOk() {
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let signs = [
        {
          key: "sortName",
          val: this.sortName, //综合查询接口路径
        },
        {
          key: "groupName",
          val: this.pageGroupName,
        },
        {
          key: "sortObject",
          val: JSON.stringify(sortObject),
        },
      ];

      let sign = this.$TOOLS.getMD5Sign(signs);

      let param = {
        // apiPath: apiList.api_packageList, //综合查询接口路径
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
        sign: sign,
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.getGroupFindFieldSort();
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    // 合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property == that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
  },
};
</script>

<style scoped lang='less'>
.box {
  width: 100%;
  display: flex;
}
.boxleft {
  // width: 40%;
  width: 380px;
  //   min-width: 390px;
  //   height: 88vh;
  overflow: auto;
  margin-right: 20px;
  // border: 1px solid #d7d7d7;
}
.boxright {
  // width: 70%;
  flex: 1;
  overflow: hidden;
  // height: 500px;
  // width: calc(100% - 430px);
}
.tablebut {
  margin-left: 15px;
}
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}

.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
    display: flex;
    .inputstyle {
      width: 100%;
      display: flex;
    }
  }
}

.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}

.frominput ::v-deep {
  .el-input__inner {
    height: 30px;
  }
}
</style>